module.exports = __webpack_public_path__ + "static/media/fullscreen.c70b44cb.svg";